// src/components/Tag.js
import React from "react";

function getContrastYIQ(hexColor) {
    let hex = hexColor.replace(/^#/, "");
    if (hex.length === 3) {
        hex = hex
            .split("")
            .map((c) => c + c)
            .join("");
    }
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "#000000" : "#ffffff";
}

const Tag = ({ name, colour = "#000000", description, disabled }) => {
    const textColor = getContrastYIQ(colour);

    return (
        <span
            title={description || name}
            style={{
                backgroundColor: colour,
                color: textColor,
                padding: "0.2em 0.5em",
                borderRadius: "0.25rem",
                display: disabled ? "none" : "inline-block",
                //opacity: disabled ?  0.25 : 1
            }}
            className="m-1"
        >
            {name}
        </span>
    );
};

export default Tag;
